//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Loader from "./components/Loader";
import SearchForm from "./components/SearchForm";

export default {
	name: "OrganizationSearchApp",
	components: {
		SearchForm,
		Loader,
	},
	data() {
		return {
			// imgPath: null,
			endpoint: null,
			userDistrictId: null,
			loaded: false,
			orgList: [],
		};
	},
	computed: {},
	methods: {
		async getLinkData() {
			const req = new Request(this.endpoint);
			fetch(req)
				.then((res) => {
					if (!res.ok) {
						throw new Error(`HTTP error! Status: ${res.status}`);
					} else {
						return res.json();
					}
				})
				.then((data) => {
					// console.log(data)
					this.orgList = data.data;
					// console.log(this.orgList);
					this.loaded = true;
				});
		},
		getCookie(cname) {
			var name = cname + "=";
			var decodedCookie = decodeURIComponent(document.cookie);
			var ca = decodedCookie.split(';');
			for(var i = 0; i <ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return false;
		},
	},
	async created() {
		this.endpoint = this.$root.apiEndpoint;
		this.userDistrictId = this.getCookie("currentDistrictId") ? this.getCookie("currentDistrictId") : null;
		await this.getLinkData();

		// Below not needed per Andy - 10/20/22 (remove if decision is final)
		// if (!!this.$root.imgPath) this.imgPath = this.$root.imgPath;
		// else this.imgPath = "/img/template-images/tasb-logo_header.svg";
	},
};
